// @flow
import React from 'react';
import {StyleSheet, View, ScrollView} from 'react-native';
import Header from './Header';
import Footer from './Footer';

const GradientPage = ({children, maxWidth, showFooter=false}: {children?: any, maxWidth?: number, showFooter?: boolean}) => {
  return (
    <View style={styles.root}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}>
        <Header />
        <View style={styles.contentWrapper}>
          <View style={[styles.innerContainer, {maxWidth: maxWidth || 1500}]}>{children}</View>
        </View>
        {showFooter && <Footer />}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    minWidth: 320,
  },
  scrollView: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#efeff0',
  },
  scrollContent: {
    flexGrow: 1,
  },
  contentWrapper: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    paddingVertical: 30,
  },
  innerContainer: {
    flex: 1,
    width: '100%',
    paddingHorizontal: 20,
  },
});

export default GradientPage;
